import React, { useState } from 'react';
import { Button, Textarea } from 'tdesign-react';
import type { TextareaProps } from 'tdesign-react/lib/textarea';

export const TextareaSearch: React.FC<
{
  getFieldDecorator: any;
  onChange: (key: any) => void;
  value: any;
  btnContext: string;
  onBtnClick: (value: string[]) => void;
} & TextareaProps
> = (props) => {
  const [compValue, setCompValue] = useState<string>('');

  const handleChangeComplete = (value: string) => {
    let tmpValue = value;
    tmpValue = value.replace(/[\r\n]/g, ',');
    setCompValue(tmpValue);
    props.onChange(tmpValue.split(','));
  };

  const handleBtnClick = () => {
    const val = compValue ? compValue.split(',') : [];
    props.onBtnClick(val);
  };

  return (
    <>
      <Textarea
        {...props}
        onChange={(val) => {
          handleChangeComplete(val);
        }}
      />
      {props.btnContext ? (
        <Button size="small" style={{ float: 'right', margin: '10px 0' }} theme="primary" onClick={handleBtnClick}>
          {props.btnContext}
        </Button>
      ) : null}
    </>
  );
};
